/**
 *  @class
 *  @function Cart
 */
class Cart {

  constructor() {
    this.container = document.getElementById('Cart');
    this.setupEventListeners();
  }
  onChange(event) {
    if (event.target.type == 'number') {
      this.updateQuantity(event.target.dataset.index, event.target.value);
    } else if (event.target.getAttribute('id') == 'CartSpecialInstructions') {
      this.saveNotes();
    } else if (event.target.getAttribute('id') == 'CartLorryAccess') {
      this.saveLorryAccess(event.target.checked);
    }
  }
  saveLorryAccess(checked) {
    fetch(`${theme.routes.cart_update_url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: { 'Lorry Access Confirmed': checked ? 'true' : 'false' } })
    }).catch(() => {});
  }
  saveNotes() {
    fetch(`${theme.routes.cart_update_url}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': `application/json`
      },
      body: JSON.stringify({
        'note': document.getElementById('CartSpecialInstructions').value
      })
    });
  }
  setupEventListeners() {
    this.removeProductEvent();

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    document.addEventListener('cart:refresh', (event) => {
      this.refresh();
    });

    this.container.addEventListener('change', this.debouncedOnChange.bind(this));

    this.termsCheckbox();
    new DeliveryDatePicker();
  }
  getSectionsToRender() {
    return [{
      id: 'Cart',
      section: 'main-cart',
      selector: '.thb-cart-form'
    },
    {
      id: 'cart-drawer-toggle',
      section: 'cart-bubble',
      selector: '.thb-item-count'
    }];
  }
  displayErrors(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) {
      lineItemError.removeAttribute('hidden');
      lineItemError.querySelector('.cart-item__error-text').innerHTML = message;
      this.container.querySelector(`#CartItem-${line}`).classList.remove('loading');
    }
  }
  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
  updateQuantity(line, quantity) {

    this.container.classList.add('cart-disabled');
    if (line) {
      this.container.querySelector(`#CartItem-${line}`).classList.add('loading');
    }

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });
    dispatchCustomEvent('line-item:change:start', {
      quantity: quantity
    });
    fetch(`${theme.routes.cart_change_url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': `application/json`
      },
      ...{
        body
      }
    })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);


        if (parsedState.errors) {
          this.displayErrors(line, parsedState.errors);
          this.container.classList.remove('cart-disabled');
          return;
        }

        this.renderContents(parsedState, line, false);

        this.container.classList.remove('cart-disabled');

        dispatchCustomEvent('line-item:change:end', {
          quantity: quantity,
          cart: parsedState
        });
      });
  }
  refresh() {
    this.container.classList.add('cart-disabled');

    let sections = 'main-cart';

    fetch(`${window.location.pathname}/?sections=${sections}`)
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);


        if (parsedState.errors) {
          this.displayErrors(line, parsedState.errors);
          this.container.classList.remove('cart-disabled');
          return;
        }

        this.renderContents(parsedState, false, true);

        this.container.classList.remove('cart-disabled');
      });
  }
  termsCheckbox() {
    const checkout_button = this.container.querySelector('.button.checkout-button');
    if (!checkout_button) return;

    const terms_checkbox = this.container.querySelector('#CartTerms');
    const palletTerms = this.container.querySelector('#palletTerms');
    const lorryAccess = this.container.querySelector('#CartLorryAccess');
    const deliveryDate = this.container.querySelector('#CartDeliveryDate');
    const preferCollect = this.container.querySelector('#CartPreferCollect');

    if (terms_checkbox) terms_checkbox.setCustomValidity(theme.strings.requiresTerms);
    if (palletTerms) palletTerms.setCustomValidity(theme.strings.palletTerms);
    if (lorryAccess) lorryAccess.setCustomValidity(theme.strings.lorryAccessConfirm);

    checkout_button.addEventListener('click', function(e) {
      if (terms_checkbox && !terms_checkbox.checked) {
        terms_checkbox.reportValidity();
        terms_checkbox.focus();
        e.preventDefault();
        return;
      }
      if (palletTerms && !palletTerms.checked) {
        palletTerms.reportValidity();
        palletTerms.focus();
        e.preventDefault();
        return;
      }
      if (deliveryDate && !(preferCollect && preferCollect.checked)) {
        if (!deliveryDate.value) {
          deliveryDate.setCustomValidity(theme.strings.deliveryDateRequired);
        } else {
          deliveryDate.setCustomValidity('');
        }
        if (!deliveryDate.checkValidity()) {
          deliveryDate.reportValidity();
          deliveryDate.focus();
          e.preventDefault();
          return;
        }
      }
      if (lorryAccess && !(preferCollect && preferCollect.checked) && !lorryAccess.checked) {
        lorryAccess.reportValidity();
        lorryAccess.focus();
        e.preventDefault();
      }
    });
  }
  removeProductEvent() {
    let removes = this.container.querySelectorAll('.remove');

    removes.forEach((remove) => {
      remove.addEventListener('click', (event) => {
        this.updateQuantity(event.target.dataset.index, '0');

        event.preventDefault();
      });
    });
  }
  renderContents(parsedState, line, refresh) {
    this.getSectionsToRender().forEach((section => {
      const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

      if (refresh) {
        if (parsedState[section.section]) {
          elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState[section.section], section.selector);
        }
      } else {
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
      }

      this.removeProductEvent();

      if (line && this.container.querySelector(`#CartItem-${line}`)) {
        this.container.querySelector(`#CartItem-${line}`).classList.remove('loading');
      }
      this.termsCheckbox();
    }));
    new DeliveryDatePicker();
  }
}
window.addEventListener('load', () => {
  if (typeof Cart !== 'undefined') {
    new Cart();
  }
});

class DeliveryDatePicker {
  constructor() {
    const configEl = document.getElementById('CartDeliveryConfig');
    if (!configEl) return;

    let config = {};
    try {
      config = JSON.parse(configEl.textContent);
    } catch (_) {
      return;
    }

    this.cutoffHour = config.cutoffHour !== undefined ? config.cutoffHour : 16;
    this.cutoffMinute = config.cutoffMinute !== undefined ? config.cutoffMinute : 30;
    this.leadDays = config.leadDays || 4;
    this.blockedDates = new Set(
      (config.blockedDates || []).map(d => d.trim()).filter(Boolean)
    );
    this.bankHolidays = new Set(this.ukBankHolidays());

    this.input = document.getElementById('CartDeliveryDate');
    this.errorEl = document.getElementById('CartDeliveryDateError');
    this.collectCheckbox = document.getElementById('CartPreferCollect');
    this.lorryInput = document.getElementById('CartLorryAccess');
    this.lorryWrapper = this.lorryInput ? this.lorryInput.closest('.cart__lorry-access') : null;
    if (!this.input) return;

    const earliest = this.earliestDate();
    this.input.min = this.formatDate(earliest);
    this.input.addEventListener('change', this.onDateChange.bind(this));

    if (this.collectCheckbox) {
      this.collectCheckbox.addEventListener('change', this.onCollectChange.bind(this));
      this.applyCollectState();
    }
  }

  applyCollectState() {
    const collecting = this.collectCheckbox && this.collectCheckbox.checked;
    const field = this.input.closest('.cart__delivery-date-field');
    if (field) field.hidden = collecting;
    this.input.disabled = collecting;
    if (this.lorryWrapper) this.lorryWrapper.hidden = collecting;
    if (this.lorryInput) this.lorryInput.disabled = collecting;
    if (collecting) {
      this.input.setCustomValidity('');
      this.clearError();
    }
  }

  onCollectChange() {
    const collecting = this.collectCheckbox.checked;
    this.applyCollectState();
    // Store the collect intent; clear the delivery details so they're removed from
    // the cart attributes when collecting (an empty value drops the attribute).
    const attributes = { 'Prefer To Collect': collecting ? 'true' : '' };
    if (collecting) {
      attributes['Requested Delivery Date'] = '';
      attributes['Lorry Access Confirmed'] = '';
    }
    this.saveAttributes(attributes);
  }

  ukBankHolidays() {
    return window.theme?.bankHolidays || [];
  }

  formatDate(date) {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  }

  isBlocked(date) {
    if (date.getDay() === 0 || date.getDay() === 6) return true;
    const s = this.formatDate(date);
    return this.bankHolidays.has(s) || this.blockedDates.has(s);
  }

  earliestDate() {
    const now = new Date();
    let ukYear = now.getFullYear(), ukMonth = now.getMonth(), ukDate = now.getDate();
    let ukHour = 24, ukMinute = 0;
    try {
      const parts = new Intl.DateTimeFormat('en-GB', {
        year: 'numeric', month: 'numeric', day: 'numeric',
        hour: 'numeric', minute: 'numeric', hour12: false, timeZone: 'Europe/London'
      }).formatToParts(now);
      ukYear = parseInt(parts.find(p => p.type === 'year').value, 10);
      ukMonth = parseInt(parts.find(p => p.type === 'month').value, 10) - 1;
      ukDate = parseInt(parts.find(p => p.type === 'day').value, 10);
      ukHour = parseInt(parts.find(p => p.type === 'hour').value, 10);
      ukMinute = parseInt(parts.find(p => p.type === 'minute').value, 10);
    } catch (_) {}
    const d = new Date(ukYear, ukMonth, ukDate);
    if (ukHour > this.cutoffHour ||
        (ukHour === this.cutoffHour && ukMinute >= this.cutoffMinute)) {
      d.setDate(d.getDate() + 1);
    }
    let guard = 0;
    while (this.isBlocked(d) && guard < 30) { d.setDate(d.getDate() + 1); guard++; }
    let remaining = this.leadDays;
    guard = 0;
    while (remaining > 0 && guard < 365) {
      d.setDate(d.getDate() + 1);
      if (!this.isBlocked(d)) remaining--;
      guard++;
    }
    return d;
  }

  onDateChange() {
    const val = this.input.value;
    if (!val) { this.clearError(); return; }

    if (val < this.input.min) {
      this.showError(theme.strings.deliveryDateTooEarly);
      this.input.value = '';
      this.input.setCustomValidity(theme.strings.deliveryDateRequired);
      return;
    }

    const [y, mo, day] = val.split('-').map(Number);
    const selected = new Date(y, mo - 1, day);

    if (this.isBlocked(selected)) {
      const isWeekend = selected.getDay() === 0 || selected.getDay() === 6;
      this.showError(isWeekend ? theme.strings.deliveryDateWeekend : theme.strings.deliveryDateUnavailable);
      this.input.value = '';
      this.input.setCustomValidity(theme.strings.deliveryDateRequired);
      return;
    }

    this.clearError();
    this.input.setCustomValidity('');
    this.saveDeliveryDate(val);
  }

  showError(msg) {
    if (!this.errorEl) return;
    this.errorEl.textContent = msg;
    this.errorEl.removeAttribute('hidden');
  }

  clearError() {
    if (!this.errorEl) return;
    this.errorEl.setAttribute('hidden', '');
    this.errorEl.textContent = '';
  }

  saveDeliveryDate(val) {
    this.saveAttributes({ 'Requested Delivery Date': val });
  }

  saveAttributes(attributes) {
    fetch(`${theme.routes.cart_update_url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes })
    }).catch(() => {});
  }
}